module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.quoteNo != '') ? _c('p', [_c('strong', [_vm._v("The Quote has successfully been cloned.")]), _c('br'), _c('br'), _vm._v("Your cloned quote reference is: "), _c('strong', [_vm._v(_vm._s(_vm.quoteNo))])]) : _vm._e(), _vm._v(" "), (_vm.quoteNo == '') ? _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Store")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.branchList,
      "placeholder": "Store",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckFields()
      }
    },
    model: {
      value: (_vm.globalModalParams.quote_id),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "quote_id", $$v)
      },
      expression: "globalModalParams.quote_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.quoteNo == '') ? _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.globalModalParams.users,
      "autocomplete": "",
      "placeholder": "User",
      "item-value": "userid",
      "item-text": "fullname",
      "solo": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckFields()
      }
    },
    model: {
      value: (_vm.globalModalParams.customer),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "customer", $$v)
      },
      expression: "globalModalParams.customer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.quoteNo == '') ? _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectList,
      "autocomplete": "",
      "placeholder": "Project",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.globalModalParams.project),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "project", $$v)
      },
      expression: "globalModalParams.project"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.quoteNo == '') ? _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Company")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.globalModalParams.survey_company),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "survey_company", $$v)
      },
      expression: "globalModalParams.survey_company"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.quoteNo == '') ? _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Starting Status")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.filterStatus,
      "autocomplete": "",
      "placeholder": "Starting Status",
      "item-value": "description",
      "item-text": "description",
      "solo": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckFields()
      }
    },
    model: {
      value: (_vm.globalModalParams.status),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams, "status", $$v)
      },
      expression: "globalModalParams.status"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-2 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.quoteNo == '') ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.canClone,
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncClone.apply(null, arguments)
      }
    }
  }, [_vm._v("Clone")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}